var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:[
    'sw-Image',
    { 'sw-Image-placeholder': _vm.showPlaceholder},
    { 'sw-Image-stateLoader': _vm.showLoader },
    { 'ui-image-lazyLoad': _vm.isLazy }
  ],attrs:{"data-srcset":_vm.dataSrcset},on:{"error":_vm.onError}})}
var staticRenderFns = []

export { render, staticRenderFns }